import { userService } from "../services";
import config from "../config/config";

export const TripPerformanceAction = {
  fetchTripPerformanceList,
};

async function fetchTripPerformanceList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchTripPerformanceList}`;
    debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
